import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import InputField from '../../../sharedcomponents/1elements/Fields/InputField';
import { makeStyles } from '@material-ui/core/styles';
import PersonAvatar from '../../../components/2compounds/PersonAvatar/PersonAvatar';
import UniversalAddress from '../../../sharedcomponents/2compounds/UniversalAddress';

const LeftChild = ({
  formikProps,
  editMode,
  partyTypes,
  jobTitles,
  activateType
}) => {
  const classes = useStyles()
  const values = formikProps.values
  const [isContactOnly, setIsContactOnly] = useState(false);

  const { partyId } = useParams();

  const onAvatarUpdate = (newUrl) => {
    formikProps.setFieldValue('avatar_url', newUrl);
  };

  return (
    <div className={classes.root}>
      <div className={classes.top}>
        <div className={classes.leftPanel}>
          <div className={classes.nameWrapper}>
            <div className={classes.nameItem}>
              <InputField
                type='text'
                name='first_name'
                maxLength={150}
                required={true}
                label='First Name'
                value={values?.first_name}
                editMode={editMode}
              />
            </div>
            <div className={classes.nameItem}>
              <InputField
                type='text'
                name='last_name'
                maxLength={150}
                required={true}
                label='Last Name'
                value={values?.last_name}
                editMode={editMode}
              />
            </div>
          </div>
          <InputField
            type='phone'
            name='phone'
            label='Phone Number'
            value={values?.phone}
            values={values}
            setFieldValue={formikProps.setFieldValue}
            editMode={editMode}
          />
          <InputField
            type='email'
            name='email'
            maxLength={150}
            required={true}
            label='Email'
            value={values?.email}
            editMode={editMode}
          />
          <UniversalAddress
            values={formikProps.values}
            editMode={editMode}
            setFieldValue={formikProps.setFieldValue}
          />
        </div>
        <div className={classes.rightPanel}>
          <PersonAvatar
            editMode={editMode}
            userId={partyId}
            onSave={onAvatarUpdate}
            name={
              formikProps.values.first_name + ' ' + formikProps.values.last_name
            }
          />
          <InputField
            type='select'
            name='job_title_id'
            required={true}
            label='Job Title'
            setFieldValue={formikProps.setFieldValue}
            options={
              jobTitles &&
              jobTitles.map(oneOption => ({
                key: oneOption.id,
                value: oneOption.id,
                text: oneOption.name
              }))
            }
            value={values?.job_title_id}
            editMode={editMode}
          />
          <InputField
            type='select'
            name='type_id'
            maxLength={150}
            options={
              partyTypes &&
              partyTypes.map(oneOption => ({
                key: oneOption.id,
                value: oneOption.id,
                text: oneOption.name
              }))
            }
            label='Category'
            value={values?.type_id}
            editMode={editMode}
            setFieldValue={formikProps.setFieldValue}
          />
          <div style={{ display: 'none' }}>
            <InputField
              type='hidden'
              name="type"
              value={values?.type}
              editModel={false}
            />
            <InputField
              type='hidden'
              name="assertGuest"
              value={values?.assertGuest}
              editModel={false}
            />
          </div>
        </div>
      </div>
      <div className={classes.bottom}>
        <FormControlLabel
          control={
            <Checkbox
              checked={isContactOnly}
              onChange={() => {
                activateType('contact')
                formikProps.setFieldValue('type', 'contact')
                formikProps.setFieldValue('assertGuest', false)
                setIsContactOnly(true);
              }}
              name="contactOnly"
              color="primary"
              disabled={isContactOnly}
            />
          }
          label="Contact Only"
        />
      </div>
    </div>
  )
}

export default LeftChild

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    '& >*': {
      boxSizing: 'border-box'
    }
  },
  top: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row'
  },
  bottom: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '25px'
  },
  leftPanel: {
    width: '60%',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 10px 0 0'
  },
  rightPanel: {
    width: '40%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '0 0 0 10px'
  },
  nameWrapper: {
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  nameItem: {
    width: '50%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
}))
